import { h as Qe, defineComponent as Ze, ref as m, computed as p, watch as j, onMounted as Vt, onUnmounted as Xe, openBlock as i, createElementBlock as u, Fragment as ne, createElementVNode as v, createVNode as f, unref as g, createBlock as xe, createCommentVNode as h, toDisplayString as z, normalizeStyle as A, withModifiers as M, normalizeClass as E, nextTick as Ue, Transition as we, withCtx as me, renderList as Lt, renderSlot as H, mergeProps as Pt, createTextVNode as Zt, normalizeProps as Bt, guardReactiveProps as Rt, TransitionGroup as dl } from "vue";
import k from "@lunagoai/vue-ui/components/BaseIcon.vue";
import ml from "@lunagoai/vue-ui/components/BaseContextMenu.vue";
const hl = (o) => {
  for (const d in o)
    if (d.startsWith("aria-") || d === "role" || d === "title")
      return !0;
  return !1;
};
const Dt = (o) => o === "";
const fl = (...o) => o.filter((d, b, l) => !!d && d.trim() !== "" && l.indexOf(d) === b).join(" ").trim();
const Et = (o) => o.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const gl = (o) => o.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (d, b, l) => l ? l.toUpperCase() : b.toLowerCase()
);
const bl = (o) => {
  const d = gl(o);
  return d.charAt(0).toUpperCase() + d.slice(1);
};
var ye = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const yl = ({
  name: o,
  iconNode: d,
  absoluteStrokeWidth: b,
  "absolute-stroke-width": l,
  strokeWidth: I,
  "stroke-width": a,
  size: s = ye.width,
  color: R = ye.stroke,
  ...T
}, { slots: y }) => Qe(
  "svg",
  {
    ...ye,
    ...T,
    width: s,
    height: s,
    stroke: R,
    "stroke-width": Dt(b) || Dt(l) || b === !0 || l === !0 ? Number(I || a || ye["stroke-width"]) * 24 / Number(s) : I || a || ye["stroke-width"],
    class: fl(
      "lucide",
      T.class,
      ...o ? [`lucide-${Et(bl(o))}-icon`, `lucide-${Et(o)}`] : ["lucide-icon"]
    ),
    ...!y.default && !hl(T) && { "aria-hidden": "true" }
  },
  [...d.map((O) => Qe(...O)), ...y.default ? [y.default()] : []]
);
const S = (o, d) => (b, { slots: l, attrs: I }) => Qe(
  yl,
  {
    ...I,
    ...b,
    iconNode: d,
    name: o
  },
  l
);
const Ke = S("check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
const pl = S("chevron-down", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
const wl = S("chevron-left", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
const xl = S("chevron-up", [
  ["path", { d: "m18 15-6-6-6 6", key: "153udz" }]
]);
const Ot = S("chevron-right", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
const kl = S("copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const Ml = S("download", [
  ["path", { d: "M12 15V3", key: "m9g1x1" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
]);
const Nt = S("image-off", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
const jt = S("image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const Ut = S("info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
const Il = S("layout-grid", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
]);
const W = S("loader-circle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
const _l = S("maximize", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
]);
const Cl = S("minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
const Tl = S("plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
const $l = S("rotate-cw", [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
]);
const Xt = S("x", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), zl = ["src"], Sl = {
  key: 1,
  class: "absolute inset-0 bg-gray-300 dark:bg-dark-100 overflow-hidden"
}, Ll = { class: "absolute inset-0 flex items-center justify-center" }, Pl = {
  key: 2,
  class: "image-progress"
}, Bl = { class: "min-w-0 flex-1" }, Rl = { class: "image-progress__label" }, Dl = {
  key: 0,
  class: "image-progress__track"
}, El = {
  key: 0,
  class: "text-white/80 text-xs"
}, Ol = ["src", "alt"], jl = /* @__PURE__ */ Ze({
  __name: "BaseImageLoader",
  props: {
    src: {},
    alt: { default: "" },
    objectFit: { default: "cover" },
    lazy: { type: Boolean, default: !0 },
    previewSrc: {},
    compact: { type: Boolean, default: !1 },
    retryLabel: { default: "Click to retry" },
    resolveSrc: {},
    progress: {},
    preparingLabel: { default: "Preparing image..." },
    downloadingLabel: { default: "Downloading" }
  },
  setup(o) {
    const d = o, b = m("idle"), l = m(0), I = m(""), a = m(""), s = p(() => I.value || a.value), R = m(null), T = p(() => {
      const $ = d.progress?.percent;
      return Number.isFinite($) ? Math.max(0, Math.min(100, Math.round($ ?? 0))) : 0;
    }), y = p(() => d.progress?.label ? d.progress.label : T.value > 0 ? `${d.downloadingLabel} ${T.value}%` : d.progress?.phase === "downloading" ? `${d.downloadingLabel}...` : d.preparingLabel), O = p(() => b.value === "loading" && !!d.progress);
    let X = null, w = 0, U = !1;
    function ke($) {
      a.value = l.value ? `${$}${$.includes("?") ? "&" : "?"}_r=${l.value}` : $;
    }
    async function V() {
      if (!d.src) return;
      U = !0, b.value = "loading", I.value = "", a.value = "";
      const $ = ++w;
      if (!d.resolveSrc) {
        ke(d.src);
        return;
      }
      try {
        const L = await d.resolveSrc(d.src);
        $ === w && (I.value = L || d.src);
      } catch {
        $ === w && (b.value = "error");
      }
    }
    function se() {
      l.value++, V();
    }
    function ie() {
      b.value = "loaded";
    }
    function Ne() {
      b.value = "error";
    }
    return j(() => d.src, ($) => {
      l.value = 0, w++, I.value = "", a.value = "", b.value = "idle", $ && (!d.lazy || U) && V();
    }), Vt(() => {
      if (d.src) {
        if (!d.lazy) {
          V();
          return;
        }
        X = new IntersectionObserver(($) => {
          $[0]?.isIntersecting && (V(), X?.disconnect(), X = null);
        }, { rootMargin: "200px" }), R.value && X.observe(R.value);
      }
    }), Xe(() => {
      X?.disconnect(), w++;
    }), ($, L) => (i(), u("div", {
      ref_key: "rootRef",
      ref: R,
      class: "absolute inset-0 overflow-hidden"
    }, [
      b.value === "idle" || b.value === "loading" ? (i(), u(ne, { key: 0 }, [
        o.previewSrc ? (i(), u("img", {
          key: 0,
          src: o.previewSrc,
          class: "absolute inset-0 w-full h-full object-cover blur-sm scale-105",
          "aria-hidden": "true"
        }, null, 8, zl)) : (i(), u("div", Sl, [
          L[0] || (L[0] = v("div", { class: "shimmer" }, null, -1)),
          v("div", Ll, [
            f(k, {
              name: g(W),
              size: 20,
              class: "animate-spin text-gray-400 dark:text-white/20"
            }, null, 8, ["name"])
          ])
        ])),
        O.value ? (i(), u("div", Pl, [
          T.value ? h("", !0) : (i(), xe(k, {
            key: 0,
            name: g(W),
            size: o.compact ? 14 : 16,
            class: "animate-spin"
          }, null, 8, ["name", "size"])),
          v("div", Bl, [
            v("div", Rl, z(y.value), 1),
            T.value ? (i(), u("div", Dl, [
              v("div", {
                class: "image-progress__bar",
                style: A({ width: `${T.value}%` })
              }, null, 4)
            ])) : h("", !0)
          ])
        ])) : h("", !0)
      ], 64)) : b.value === "error" ? (i(), u("div", {
        key: 1,
        class: "absolute inset-0 flex flex-col items-center justify-center gap-2 bg-black/50 cursor-pointer select-none",
        onClick: M(se, ["stop"])
      }, [
        f(k, {
          name: g(Nt),
          size: o.compact ? 16 : 24,
          class: "text-white/70"
        }, null, 8, ["name", "size"]),
        o.compact ? h("", !0) : (i(), u("span", El, z(o.retryLabel), 1))
      ])) : h("", !0),
      s.value ? (i(), u("img", {
        key: 2,
        src: s.value,
        alt: o.alt,
        class: E([
          "absolute inset-0 w-full h-full transition-opacity duration-300",
          o.objectFit === "contain" ? "object-contain" : "object-cover",
          b.value === "loaded" ? "opacity-100" : "opacity-0 pointer-events-none"
        ]),
        onLoad: ie,
        onError: Ne
      }, null, 42, Ol)) : h("", !0)
    ], 512));
  }
}), Je = (o, d) => {
  const b = o.__vccOpts || o;
  for (const [l, I] of d)
    b[l] = I;
  return b;
}, Ve = /* @__PURE__ */ Je(jl, [["__scopeId", "data-v-15859e47"]]), Ul = { class: "lmui-lightbox-image-stage" }, Xl = ["src"], Vl = { class: "lmui-lightbox-image-stage" }, Zl = {
  key: 0,
  class: "lmui-lightbox-main-progress",
  "data-main-image-spinner": "true"
}, Nl = { class: "lmui-lightbox-main-progress__body" }, Fl = { class: "lmui-lightbox-main-progress__label" }, Al = {
  key: 0,
  class: "lmui-lightbox-main-progress__track"
}, Gl = ["src"], Yl = { class: "text-sm text-white/60" }, ql = { class: "px-4 py-1.5 rounded-full bg-white/10 hover:bg-white/20 text-white/70 text-sm transition-colors" }, Wl = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center pointer-events-none"
}, Hl = {
  key: 1,
  class: "flex items-center justify-center w-24 h-24"
}, Kl = { class: "lmui-lightbox-image-stage" }, Ql = ["src"], Jl = { class: "lmui-lightbox-gallery-inner" }, ea = { class: "lmui-lightbox-gallery-grid" }, ta = ["onClick", "onContextmenu", "onTouchstartPassive"], la = {
  key: 0,
  class: "w-full h-full bg-white/10 flex items-center justify-center"
}, aa = {
  key: 2,
  class: "absolute inset-0 bg-amber-500/10 pointer-events-none flex items-end justify-end p-2"
}, oa = { class: "bg-amber-500 text-white rounded-full p-1 shadow-lg" }, na = {
  key: 3,
  class: "absolute inset-0 bg-blue-500/10 pointer-events-none"
}, sa = ["aria-label"], ia = ["aria-label"], ua = ["title", "aria-label"], ra = ["title", "aria-label"], ca = ["title", "aria-label"], va = ["title", "aria-label"], da = ["title", "aria-label"], ma = ["title", "aria-label"], ha = {
  key: 2,
  class: "lmui-lightbox-gallery-title"
}, fa = {
  key: 1,
  class: "absolute top-4 left-1/2 -translate-x-1/2 z-20 text-center pointer-events-none hidden md:block bg-black/20 backdrop-blur-md rounded-full px-3 py-1.5 border border-white/5"
}, ga = { class: "text-white/80 text-xs font-medium tracking-wide" }, ba = { class: "text-white/40 text-[10px] uppercase font-mono ml-1.5" }, ya = ["disabled", "title", "aria-label"], pa = ["disabled", "title", "aria-label"], wa = ["title", "aria-label"], xa = ["title", "aria-label"], ka = {
  key: 2,
  class: "absolute bottom-24 left-1/2 -translate-x-1/2 z-50 pointer-events-none flex flex-col items-center gap-1"
}, Ma = { class: "bg-black/70 text-white text-xs font-mono px-3 py-1.5 rounded-full backdrop-blur-sm" }, Ia = { class: "w-48 h-1.5 bg-white/20 rounded-full relative overflow-hidden" }, _a = { class: "flex items-center justify-between mb-4" }, Ca = { class: "flex items-center gap-2" }, Ta = { class: "text-white font-medium text-sm" }, $a = { class: "space-y-4" }, za = { class: "lmui-lightbox-footer" }, Sa = ["title", "aria-label"], La = ["data-thumb-idx", "data-thumb-key", "aria-label", "onClick", "onContextmenu", "onTouchstartPassive"], Pa = {
  key: 0,
  class: "w-full h-full bg-white/10 flex items-center justify-center"
}, Ba = ["disabled", "aria-label"], pe = 80, Ra = 0.8, Da = /* @__PURE__ */ Ze({
  __name: "BaseImageLightbox",
  props: {
    images: {},
    modelValue: {},
    isOpen: { type: Boolean },
    showThumbnails: { type: Boolean, default: !0 },
    showNavigation: { type: Boolean, default: !0 },
    enableZoom: { type: Boolean, default: !0 },
    enablePan: { type: Boolean, default: !0 },
    enableDownload: { type: Boolean, default: !0 },
    showInfo: { type: Boolean, default: !0 },
    showRotate: { type: Boolean, default: !0 },
    loop: { type: Boolean, default: !0 },
    closeOnBackdropClick: { type: Boolean, default: !0 },
    showSwipeDebug: { type: Boolean, default: !1 },
    disableKeyboard: { type: Boolean, default: !1 },
    initialGalleryMode: { type: Boolean, default: !1 },
    galleryMode: { type: Boolean, default: void 0 },
    gallerySelected: {},
    gallerySelectMode: { type: Boolean },
    persistZoom: { type: Boolean },
    isMobile: { type: Boolean },
    resolveImageUrl: {},
    hasMore: { type: Boolean, default: !1 },
    loadingMore: { type: Boolean, default: !1 },
    loadMoreThreshold: { default: 6 },
    imageProgress: {},
    labels: {},
    notifySuccess: {},
    notifyError: {}
  },
  emits: ["update:modelValue", "update:isOpen", "thumbnail-contextmenu", "gallery-contextmenu", "gallery-item-click", "need-more"],
  setup(o, { expose: d, emit: b }) {
    const l = o, I = b, a = p(() => ({
      loadFailed: "Failed to load image",
      clickToRetry: "Click to retry",
      toggleGallery: "Toggle thumbnails",
      zoomOut: "Zoom out",
      zoomIn: "Zoom in",
      actualSize: "Actual size (100%)",
      resetView: "Reset view",
      rotate: "Rotate clockwise 90 degrees",
      copyImage: "Copy image",
      downloadImage: "Download image",
      imageInfo: "Image info",
      imageList: "Images",
      closeImageList: "Close images",
      closeLightbox: "Close lightbox",
      showThumbnails: "Show thumbnails",
      hideThumbnails: "Hide thumbnails",
      openImage: "Open image",
      zoomInMenu: "Zoom in",
      zoomOutMenu: "Zoom out",
      rotateMenu: "Rotate 90 degrees",
      copySuccessTitle: "Copied",
      copySuccessMessage: "Image copied to clipboard",
      copyErrorTitle: "Copy failed",
      copyErrorMessage: "Unable to copy image",
      downloadSuccessTitle: "Downloading",
      downloadSuccessMessage: "Image download started",
      downloadErrorTitle: "Download failed",
      downloadErrorMessage: "Unable to download image",
      previousImage: "Previous image",
      nextImage: "Next image",
      loadMoreImages: "Load more images",
      loadingMoreImages: "Loading more images",
      preparingImage: "Preparing image...",
      downloadingImage: "Downloading",
      ...l.labels
    })), s = p({
      get: () => l.modelValue,
      set: (e) => I("update:modelValue", e)
    }), R = m(!1), T = m(!0), y = p(() => l.images.map((e) => typeof e == "string" ? { url: e } : e)), O = p(() => y.value[s.value] || { url: "" }), X = m(0);
    function w(e, t) {
      return e ? String(e.id || e.path || e.url || `index:${t ?? ""}`) : `missing:${t ?? ""}`;
    }
    function U(e) {
      return e ? Object.prototype.hasOwnProperty.call(e, "previewUrl") ? e.previewUrl || "" : e.url : "";
    }
    function ke(e) {
      return e ? typeof e == "string" ? { url: e } : e : null;
    }
    const V = p(() => w(O.value, s.value)), se = p(() => l.imageProgress?.(O.value, s.value) ?? null), ie = p(() => {
      const e = se.value?.percent;
      return Number.isFinite(e) ? Math.max(0, Math.min(100, Math.round(e ?? 0))) : 0;
    }), Ne = p(() => se.value?.label ? se.value.label : ie.value > 0 ? `${a.value.downloadingImage} ${ie.value}%` : se.value?.phase === "downloading" ? `${a.value.downloadingImage}...` : a.value.preparingImage);
    function $(e = !1) {
      const t = y.value.length;
      if (!l.hasMore || l.loadingMore || t === 0) return;
      const n = Math.max(0, t - l.loadMoreThreshold), r = s.value >= n;
      if (!e && !r) {
        s.value < n - 1 && (X.value = 0);
        return;
      }
      !e && X.value === t || (X.value = t, I("need-more", { index: s.value, length: t }));
    }
    const L = m(/* @__PURE__ */ new Map()), ue = m(/* @__PURE__ */ new Set()), Me = /* @__PURE__ */ new Set();
    let Z = null;
    const re = m("next");
    function Ft() {
      L.value = /* @__PURE__ */ new Map(), ue.value = /* @__PURE__ */ new Set(), Me.clear(), Z !== null && (clearTimeout(Z), Z = null);
    }
    function At() {
      const e = new Set(y.value.map((n, r) => w(n, r))), t = /* @__PURE__ */ new Map();
      for (const [n, r] of L.value.entries())
        e.has(n) && t.set(n, r);
      L.value = t;
    }
    function et(e, t, n) {
      const r = y.value[e], c = w(r, e);
      !r?.resolve || L.value.has(c) || Me.has(c) || (Me.add(c), r.resolve({ priority: t, direction: n }).then((B) => {
        L.value = new Map(L.value).set(c, B);
        const de = new Set(ue.value);
        de.delete(c), ue.value = de;
      }).catch(() => {
        const B = new Set(ue.value).add(c);
        ue.value = B, V.value === c && (G.value = !0);
      }).finally(() => {
        Me.delete(c), t === "current" && V.value === c && Yt();
      }));
    }
    function tt(e) {
      Z !== null && (clearTimeout(Z), Z = null), et(e, "current");
    }
    function Gt(e) {
      const t = y.value.length;
      return t <= 1 ? -1 : e === "prev" ? s.value > 0 ? s.value - 1 : t - 1 : s.value < t - 1 ? s.value + 1 : 0;
    }
    function Yt() {
      Z !== null && clearTimeout(Z);
      const e = re.value, t = Gt(e);
      if (t < 0) return;
      const n = w(y.value[t], t);
      L.value.has(n) || (Z = setTimeout(() => {
        Z = null, s.value !== t && et(t, "preload", e);
      }, 900));
    }
    j(() => s.value, tt, { immediate: !0 }), j(
      [() => s.value, () => y.value.length, () => l.hasMore, () => l.loadingMore],
      () => $(),
      { immediate: !0 }
    ), j(() => l.images, (e, t) => {
      const n = ke(t?.[s.value]), r = w(n, s.value), c = y.value.findIndex((B, de) => w(B, de) === r);
      if (At(), c >= 0 && c !== s.value) {
        s.value = c;
        return;
      }
      if (s.value >= y.value.length) {
        s.value = Math.max(0, y.value.length - 1);
        return;
      }
      tt(s.value);
    }), Xe(() => {
      Ft();
    });
    const N = p(() => L.value.get(V.value) || U(O.value)), Ie = p(() => L.value.has(V.value)), qt = p(() => ue.value.has(V.value)), lt = p(
      () => !!O.value.resolve && !Ie.value && !qt.value
    ), G = m(!1), _e = m(!1), Ce = m(0), K = m(""), Fe = p(
      () => lt.value
    ), Wt = p(
      () => !!N.value && (Fe.value || _e.value || Ie.value)
    ), at = p(() => {
      if (!Ce.value) return N.value;
      const e = N.value.includes("?") ? "&" : "?";
      return `${N.value}${e}_r=${Ce.value}`;
    });
    function Ht() {
      _e.value = !0, G.value = !1, K.value = "", Ge();
    }
    function Kt() {
      if (lt.value) {
        K.value = at.value;
        return;
      }
      G.value = !0;
    }
    function Qt() {
      Ce.value++, G.value = !1, K.value = "";
    }
    j(s, () => {
      _e.value = Ie.value, G.value = !1, K.value = "";
    }), j(N, (e, t) => {
      e !== t && (_e.value = Ie.value, G.value = K.value === e, K.value = "");
    });
    const Te = p(() => {
      if (!Le.value) return null;
      const e = s.value > 0 ? s.value - 1 : y.value.length - 1;
      return y.value[e] ?? null;
    }), $e = p(() => {
      if (!Pe.value) return null;
      const e = s.value < y.value.length - 1 ? s.value + 1 : 0;
      return y.value[e] ?? null;
    }), ot = p(() => {
      if (!Te.value) return "";
      const e = s.value > 0 ? s.value - 1 : y.value.length - 1;
      return L.value.get(w(Te.value, e)) || U(Te.value);
    }), nt = p(() => {
      if (!$e.value) return "";
      const e = s.value < y.value.length - 1 ? s.value + 1 : 0;
      return L.value.get(w($e.value, e)) || U($e.value);
    }), ze = m(null);
    function st(e = "smooth") {
      if (!ze.value) return;
      const t = ze.value.querySelector(`[data-thumb-idx="${s.value}"]`);
      t && t.scrollIntoView({ behavior: e, block: "nearest", inline: "center" });
    }
    j(s, () => {
      G.value = !1, Ce.value = 0, K.value = "", Ue(() => st("smooth"));
    });
    const Y = m(!1), q = m(!1), he = m(!1), fe = m(!1);
    let Q = null, J = null;
    const _ = m(l.galleryMode ?? l.initialGalleryMode), x = m(1), D = m({ x: 0, y: 0 }), ee = m(0), ge = m(!1), F = m(!1), te = m({ x: 0, y: 0 }), Se = m(0), it = m(1), C = m(0), P = m(!1);
    let Jt = 0, le = null;
    const ut = m(0), rt = m(0), ct = m(null), Ae = m(null), Le = p(() => l.loop || s.value > 0), Pe = p(() => l.loop || s.value < l.images.length - 1), Be = m(1), Ge = () => {
      const e = Ae.value;
      !e || !e.naturalWidth || (Be.value = e.clientWidth / e.naturalWidth);
    }, vt = p(() => Math.round(Be.value * x.value * 100)), el = p(() => {
      const e = D.value.x + C.value, t = D.value.y, n = x.value, r = ee.value, c = `translate(${e}px, ${t}px) scale(${n}) rotate(${r}deg)`;
      let B;
      return ge.value ? B = "none" : n <= 1 ? B = P.value ? "none" : "transform 0.3s ease-out" : B = F.value ? "none" : "transform 0.2s ease-out", { transform: c, transition: B };
    }), dt = (e, t) => Math.sqrt(
      Math.pow(t.clientX - e.clientX, 2) + Math.pow(t.clientY - e.clientY, 2)
    ), Ye = m(!1);
    let be = null;
    const mt = (e) => {
      Ye.value = e?.matches ?? be?.matches ?? !1;
    };
    typeof window < "u" && typeof window.matchMedia == "function" && (be = window.matchMedia("(max-width: 639px)"), Ye.value = be.matches, be.addEventListener("change", mt));
    const ce = p(() => l.isMobile ?? Ye.value);
    function Re(e) {
      if (!le) return;
      const t = le;
      le = null, clearTimeout(t.timer), e && (s.value = t.index, C.value = 0, D.value = { x: 0, y: 0 }, ee.value = 0, l.persistZoom || (x.value = 1));
    }
    function ht(e) {
      Re(!1);
      const t = ++Jt, n = setTimeout(() => {
        !le || le.token !== t || (le = null, P.value = !0, s.value = e, C.value = 0, D.value = { x: 0, y: 0 }, ee.value = 0, l.persistZoom || (x.value = 1), requestAnimationFrame(() => requestAnimationFrame(() => {
          P.value = !1;
        })));
      }, 300);
      le = { token: t, timer: n, index: e };
    }
    const ft = () => {
      Re(!1), I("update:isOpen", !1), ve();
    }, gt = (e) => {
      l.closeOnBackdropClick && e.target === e.currentTarget && ft();
    }, bt = () => {
      _.value = !_.value;
    }, ae = m(null);
    function tl(e, t, n) {
      const r = n.touches[0];
      if (!r) return;
      const c = r.clientX, B = r.clientY;
      ae.value = setTimeout(() => {
        ae.value = null, I("thumbnail-contextmenu", { image: e, index: t, x: c, y: B });
      }, 500);
    }
    function qe() {
      ae.value !== null && (clearTimeout(ae.value), ae.value = null);
    }
    function ll(e) {
      re.value = e >= s.value ? "next" : "prev", s.value = e, l.persistZoom ? yt() : ve();
    }
    const al = (e) => {
      if (l.gallerySelectMode) {
        I("gallery-item-click", e);
        return;
      }
      re.value = e >= s.value ? "next" : "prev", s.value = e, _.value = !1, l.persistZoom ? yt() : ve();
    }, oe = m(null);
    function ol(e, t, n) {
      const r = n.touches[0];
      if (!r) return;
      const c = r.clientX, B = r.clientY;
      oe.value = setTimeout(() => {
        oe.value = null, I("gallery-contextmenu", { image: e, index: t, x: c, y: B });
      }, 500);
    }
    function De() {
      oe.value !== null && (clearTimeout(oe.value), oe.value = null);
    }
    const yt = async () => {
      D.value = { x: 0, y: 0 }, C.value = 0, ge.value = !0, ee.value = 0, await Ue(), ge.value = !1;
    }, ve = async () => {
      x.value = 1, D.value = { x: 0, y: 0 }, C.value = 0, ge.value = !0, ee.value = 0, await Ue(), ge.value = !1;
    }, pt = () => {
      ee.value += 90;
    };
    async function We(e) {
      return l.resolveImageUrl && !e.startsWith("blob:") ? l.resolveImageUrl(e) : e;
    }
    async function wt(e) {
      const t = await We(e), n = await fetch(t);
      if (!n.ok) throw new Error(`${n.status}`);
      return n.blob();
    }
    const xt = async () => {
      if (!Y.value) {
        Q !== null && (clearTimeout(Q), Q = null), he.value = !1, Y.value = !0;
        try {
          const e = await wt(N.value);
          let t = e;
          if (e.type !== "image/png") {
            const r = await createImageBitmap(e), c = document.createElement("canvas");
            c.width = r.width, c.height = r.height, c.getContext("2d").drawImage(r, 0, 0), t = await new Promise(
              (B, de) => c.toBlob((St) => St ? B(St) : de(new Error("toBlob failed")), "image/png")
            );
          }
          const n = new ClipboardItem({ "image/png": t });
          await navigator.clipboard.write([n]), he.value = !0, Q = setTimeout(() => {
            he.value = !1, Q = null;
          }, 1400), l.notifySuccess?.(a.value.copySuccessTitle, a.value.copySuccessMessage);
        } catch (e) {
          console.error("Failed to copy image:", e), l.notifyError?.(a.value.copyErrorTitle, a.value.copyErrorMessage);
        } finally {
          Y.value = !1;
        }
      }
    }, kt = async () => {
      if (!q.value) {
        J !== null && (clearTimeout(J), J = null), fe.value = !1, q.value = !0;
        try {
          const e = await wt(N.value), t = window.URL.createObjectURL(e), n = document.createElement("a");
          n.href = t;
          const c = O.value.path?.split("/").pop() || O.value.url.split("/").pop()?.split("?")[0] || "image.png";
          n.download = c, document.body.appendChild(n), n.click(), window.URL.revokeObjectURL(t), document.body.removeChild(n), fe.value = !0, J = setTimeout(() => {
            fe.value = !1, J = null;
          }, 1400), l.notifySuccess?.(a.value.downloadSuccessTitle, a.value.downloadSuccessMessage);
        } catch (e) {
          console.error("Failed to download image:", e), l.notifyError?.(a.value.downloadErrorTitle, a.value.downloadErrorMessage);
        } finally {
          q.value = !1;
        }
      }
    }, Mt = () => {
      x.value = Math.min(5, x.value + 0.2);
    }, It = () => {
      x.value = Math.max(0.5, x.value - 0.2);
    }, _t = () => {
      Be.value > 0 && (x.value = Math.min(5, Math.max(0.5, 1 / Be.value)));
    }, Ee = m(null), nl = (e) => {
      if (_.value) {
        Ee.value = {
          x: e.clientX,
          y: e.clientY,
          items: [
            { label: a.value.closeImageList, icon: "LayoutGrid", action: () => {
              _.value = !1;
            } }
          ]
        };
        return;
      }
      Ee.value = {
        x: e.clientX,
        y: e.clientY,
        items: [
          ...l.images.length > 1 ? [
            { label: a.value.imageList, icon: "LayoutGrid", action: bt },
            { label: "---", action: () => {
            } }
          ] : [],
          { label: a.value.zoomInMenu, icon: "ZoomIn", action: Mt, disabled: x.value >= 5 },
          { label: a.value.zoomOutMenu, icon: "ZoomOut", action: It, disabled: x.value <= 0.5 },
          { label: a.value.actualSize, icon: "ScanSearch", action: _t },
          { label: a.value.resetView, icon: "Maximize", action: ve },
          ...l.showRotate ? [
            { label: a.value.rotateMenu, icon: "RotateCw", action: pt }
          ] : [],
          { label: "---", action: () => {
          } },
          { label: a.value.copyImage, icon: "Copy", action: xt, disabled: Y.value },
          ...l.enableDownload ? [
            { label: a.value.downloadImage, icon: "Download", action: kt, disabled: q.value }
          ] : []
        ]
      };
    };
    let He = null;
    const Oe = (e, t) => {
      He === null && (re.value = e, P.value = !1, C.value = e === "prev" ? window.innerWidth : -window.innerWidth, He = setTimeout(() => {
        He = null, P.value = !0, s.value = t, C.value = 0, D.value = { x: 0, y: 0 }, ee.value = 0, l.persistZoom || (x.value = 1), requestAnimationFrame(() => requestAnimationFrame(() => {
          P.value = !1;
        }));
      }, 300));
    }, Ct = () => {
      l.showNavigation && (s.value > 0 ? Oe("prev", s.value - 1) : l.loop && Oe("prev", l.images.length - 1));
    }, Tt = () => {
      l.showNavigation && (s.value < l.images.length - 1 ? Oe("next", s.value + 1) : l.loop && Oe("next", 0));
    }, sl = (e) => {
      if (!l.enableZoom) return;
      const t = 0.1, n = e.deltaY > 0 ? -t : t;
      x.value = Math.max(0.5, Math.min(5, x.value + n));
    }, il = (e) => {
      l.enablePan && (F.value = !0, te.value = { x: e.clientX - D.value.x, y: e.clientY - D.value.y });
    }, ul = (e) => {
      !F.value || !l.enablePan || (D.value = {
        x: e.clientX - te.value.x,
        y: e.clientY - te.value.y
      });
    }, $t = () => {
      F.value = !1;
    }, rl = (e) => {
      if (e.touches.length === 1) {
        Re(!0), F.value = !0;
        const t = e.touches[0];
        t && (te.value = { x: t.clientX - D.value.x, y: t.clientY - D.value.y }, ut.value = t.clientX, rt.value = Date.now(), x.value <= 1 && (P.value = !0));
      } else if (e.touches.length === 2 && l.enableZoom) {
        F.value = !1, P.value = !1;
        const t = e.touches[0], n = e.touches[1];
        t && n && (Se.value = dt(t, n), it.value = x.value);
      }
    }, cl = (e) => {
      if (e.touches.length === 1 && F.value) {
        const t = e.touches[0];
        t && (x.value <= 1 ? C.value = t.clientX - ut.value : l.enablePan && (D.value = { x: t.clientX - te.value.x, y: t.clientY - te.value.y }));
      } else if (e.touches.length === 2 && l.enableZoom) {
        const t = e.touches[0], n = e.touches[1];
        if (t && n && Se.value > 0) {
          const c = dt(t, n) / Se.value;
          x.value = Math.max(0.5, Math.min(5, it.value * c));
        }
      }
    }, vl = (e) => {
      if (e.touches.length === 0) {
        if (x.value <= 1 && F.value) {
          const t = C.value, n = Date.now() - rt.value, r = Math.abs(t) / n;
          if (Math.abs(t) > pe || r > Ra)
            if (t > 0 && Le.value) {
              re.value = "prev", P.value = !1, C.value = window.innerWidth;
              const c = s.value > 0 ? s.value - 1 : y.value.length - 1;
              ht(c);
            } else if (t < 0 && Pe.value) {
              re.value = "next", P.value = !1, C.value = -window.innerWidth;
              const c = s.value < y.value.length - 1 ? s.value + 1 : 0;
              ht(c);
            } else
              P.value = !1, C.value = 0;
          else
            P.value = !1, C.value = 0;
        }
        F.value = !1, Se.value = 0;
      } else if (e.touches.length === 1) {
        const t = e.touches[0];
        t && (F.value = !0, te.value = { x: t.clientX - D.value.x, y: t.clientY - D.value.y });
      }
    }, zt = (e) => {
      if (!(!l.isOpen || l.disableKeyboard)) {
        if (_.value) {
          e.key === "Escape" && (_.value = !1);
          return;
        }
        switch (e.key) {
          case "ArrowLeft":
            Le.value && Ct();
            break;
          case "ArrowRight":
            Pe.value && Tt();
            break;
          case "+":
            l.enableZoom && (x.value = Math.min(5, x.value + 0.2));
            break;
          case "-":
            l.enableZoom && (x.value = Math.max(0.5, x.value - 0.2));
            break;
          case "0":
            ve();
            break;
        }
      }
    };
    j(() => l.isOpen, (e) => {
      e && (_.value = l.galleryMode ?? l.initialGalleryMode, Ue(() => ct.value?.focus()));
    }, { immediate: !0 }), j(() => l.galleryMode, (e) => {
      typeof e == "boolean" && (_.value = e);
    }), j(ze, (e) => {
      e && st("instant");
    });
    let je = null;
    return j(Ae, (e) => {
      je?.disconnect(), e && (e.complete && e.naturalWidth && Ge(), je = new ResizeObserver(Ge), je.observe(e));
    }), j(() => l.isOpen, (e) => {
      e || (qe(), De());
    }), Xe(() => {
      je?.disconnect(), be?.removeEventListener("change", mt), Re(!1), Q !== null && clearTimeout(Q), J !== null && clearTimeout(J), ae.value !== null && clearTimeout(ae.value), oe.value !== null && clearTimeout(oe.value);
    }), j(x, (e, t) => {
      t <= 1 && e > 1 && (C.value = 0, P.value = !1);
    }), Vt(() => {
      window.addEventListener("keydown", zt);
    }), Xe(() => {
      window.removeEventListener("keydown", zt);
    }), d({ displayZoom: vt }), (e, t) => (i(), xe(we, { name: "fade" }, {
      default: me(() => [
        o.isOpen ? (i(), u("div", {
          key: 0,
          class: "absolute inset-0 isolate bg-black flex items-center justify-center select-none overflow-hidden outline-none",
          tabindex: "0",
          ref_key: "lightboxRef",
          ref: ct,
          onContextmenu: M(nl, ["prevent"])
        }, [
          f(we, {
            name: "fade",
            mode: "out-in"
          }, {
            default: me(() => [
              _.value ? (i(), u("div", {
                key: "gallery",
                class: "lmui-lightbox-gallery",
                onScroll: t[5] || (t[5] = (n) => De())
              }, [
                v("div", Jl, [
                  v("div", ea, [
                    (i(!0), u(ne, null, Lt(y.value, (n, r) => (i(), u("div", {
                      key: w(n, r),
                      class: E(["lmui-lightbox-gallery-item", o.gallerySelected?.has(r) ? "is-selected" : s.value === r ? "is-current" : "is-idle"]),
                      onClick: (c) => al(r),
                      onContextmenu: M((c) => I("gallery-contextmenu", { image: n, index: r, x: c.clientX, y: c.clientY }), ["prevent", "stop"]),
                      onTouchstartPassive: (c) => ol(n, r, c),
                      onTouchend: t[3] || (t[3] = (c) => De()),
                      onTouchmove: t[4] || (t[4] = (c) => De())
                    }, [
                      n.url ? (i(), xe(Ve, {
                        key: 1,
                        src: n.url,
                        "resolve-src": We,
                        "retry-label": a.value.clickToRetry
                      }, null, 8, ["src", "retry-label"])) : (i(), u("div", la, [
                        f(k, {
                          name: g(jt),
                          size: 24,
                          class: "text-white/20"
                        }, null, 8, ["name"])
                      ])),
                      o.gallerySelected?.has(r) ? (i(), u("div", aa, [
                        v("div", oa, [
                          f(k, {
                            name: g(Ke),
                            size: 14
                          }, null, 8, ["name"])
                        ])
                      ])) : s.value === r ? (i(), u("div", na)) : h("", !0),
                      H(e.$slots, "gallery-item-badge", Pt({ ref_for: !0 }, { image: n, index: r }), void 0, !0)
                    ], 42, ta))), 128))
                  ])
                ])
              ], 32)) : (i(), u("div", {
                key: "preview",
                class: "absolute inset-0 flex items-center justify-center",
                onClick: gt
              }, [
                v("div", {
                  class: "relative w-full h-full flex items-center justify-center overflow-hidden touch-none",
                  onWheel: M(sl, ["prevent"]),
                  onMousedown: il,
                  onMousemove: ul,
                  onMouseup: $t,
                  onMouseleave: $t,
                  onTouchstart: rl,
                  onTouchmove: cl,
                  onTouchend: vl,
                  onClick: gt
                }, [
                  x.value <= 1 && Te.value ? (i(), u("div", {
                    key: 0,
                    class: "absolute inset-0 flex items-center justify-center",
                    onClick: t[0] || (t[0] = M(() => {
                    }, ["stop"])),
                    style: A({ transform: `translateX(calc(-100vw + ${C.value}px))`, transition: P.value ? "none" : "transform 0.3s ease-out" })
                  }, [
                    v("div", Ul, [
                      ot.value ? (i(), u("img", {
                        key: 0,
                        src: ot.value,
                        class: "lmui-lightbox-image"
                      }, null, 8, Xl)) : h("", !0)
                    ])
                  ], 4)) : h("", !0),
                  v("div", {
                    class: "absolute inset-0 flex items-center justify-center",
                    onClick: t[1] || (t[1] = M(() => {
                    }, ["stop"])),
                    style: A(el.value)
                  }, [
                    v("div", Vl, [
                      G.value ? (i(), u("div", {
                        key: 1,
                        class: "flex flex-col items-center justify-center gap-3 text-white/60 cursor-pointer",
                        onClick: M(Qt, ["stop"])
                      }, [
                        f(k, {
                          name: g(Nt),
                          size: 40,
                          class: "text-white/40"
                        }, null, 8, ["name"]),
                        v("span", Yl, z(a.value.loadFailed), 1),
                        v("span", ql, z(a.value.clickToRetry), 1)
                      ])) : (i(), u(ne, { key: 0 }, [
                        Fe.value && N.value ? (i(), u("div", Zl, [
                          f(k, {
                            name: g(W),
                            size: 22,
                            class: "animate-spin"
                          }, null, 8, ["name"]),
                          v("div", Nl, [
                            v("div", Fl, z(Ne.value), 1),
                            ie.value > 0 ? (i(), u("div", Al, [
                              v("div", {
                                class: "lmui-lightbox-main-progress__bar",
                                style: A({ width: `${ie.value}%` })
                              }, null, 4)
                            ])) : h("", !0)
                          ])
                        ])) : h("", !0),
                        N.value ? (i(), u("img", {
                          key: 1,
                          src: at.value,
                          class: E([
                            "lmui-lightbox-image transition-opacity duration-300",
                            Wt.value ? "opacity-100" : "opacity-0"
                          ]),
                          ref_key: "imageRef",
                          ref: Ae,
                          onLoad: Ht,
                          onError: Kt
                        }, null, 42, Gl)) : h("", !0)
                      ], 64)),
                      !N.value && !G.value ? (i(), u(ne, { key: 2 }, [
                        Fe.value ? (i(), u("div", Wl, [
                          f(k, {
                            name: g(W),
                            size: 36,
                            class: "animate-spin text-white/55"
                          }, null, 8, ["name"])
                        ])) : (i(), u("div", Hl, [
                          f(k, {
                            name: g(W),
                            size: 36,
                            class: "animate-spin text-white/50"
                          }, null, 8, ["name"])
                        ]))
                      ], 64)) : h("", !0)
                    ])
                  ], 4),
                  x.value <= 1 && $e.value ? (i(), u("div", {
                    key: 1,
                    class: "absolute inset-0 flex items-center justify-center",
                    onClick: t[2] || (t[2] = M(() => {
                    }, ["stop"])),
                    style: A({ transform: `translateX(calc(100vw + ${C.value}px))`, transition: P.value ? "none" : "transform 0.3s ease-out" })
                  }, [
                    v("div", Kl, [
                      nt.value ? (i(), u("img", {
                        key: 0,
                        src: nt.value,
                        class: "lmui-lightbox-image"
                      }, null, 8, Ql)) : h("", !0)
                    ])
                  ], 4)) : h("", !0)
                ], 32)
              ]))
            ]),
            _: 3
          }),
          !ce.value && !_.value && o.showNavigation && o.images.length > 1 ? (i(), u(ne, { key: 0 }, [
            Le.value ? (i(), u("button", {
              key: 0,
              class: "lmui-lightbox-nav lmui-lightbox-nav-prev",
              onClick: M(Ct, ["stop"]),
              "aria-label": a.value.previousImage
            }, [
              f(k, {
                name: g(wl),
                size: 32
              }, null, 8, ["name"])
            ], 8, sa)) : h("", !0),
            Pe.value ? (i(), u("button", {
              key: 1,
              class: "lmui-lightbox-nav lmui-lightbox-nav-next",
              onClick: M(Tt, ["stop"]),
              "aria-label": a.value.nextImage
            }, [
              f(k, {
                name: g(Ot),
                size: 32
              }, null, 8, ["name"])
            ], 8, ia)) : h("", !0)
          ], 64)) : h("", !0),
          v("div", {
            class: E(["lmui-lightbox-toolbar", { "is-mobile": ce.value, "is-gallery": _.value }])
          }, [
            o.images.length > 1 ? (i(), u("button", {
              key: 0,
              class: E(["lmui-lightbox-toolbar-button", { "is-active": _.value }]),
              onClick: M(bt, ["stop"]),
              title: a.value.toggleGallery,
              "aria-label": a.value.toggleGallery
            }, [
              f(k, {
                name: g(Il),
                size: 18
              }, null, 8, ["name"])
            ], 10, ua)) : h("", !0),
            _.value ? (i(), u("span", ha, z(a.value.imageList), 1)) : (i(), u(ne, { key: 1 }, [
              o.enableZoom ? (i(), u("div", {
                key: 0,
                class: E(["lmui-lightbox-toolbar-group", { "has-divider": o.images.length > 1 }])
              }, [
                v("button", {
                  class: "lmui-lightbox-toolbar-button",
                  onClick: M(It, ["stop"]),
                  title: a.value.zoomOut,
                  "aria-label": a.value.zoomOut
                }, [
                  f(k, {
                    name: g(Cl),
                    size: 18
                  }, null, 8, ["name"])
                ], 8, ra),
                v("button", {
                  class: "lmui-lightbox-toolbar-button",
                  onClick: M(Mt, ["stop"]),
                  title: a.value.zoomIn,
                  "aria-label": a.value.zoomIn
                }, [
                  f(k, {
                    name: g(Tl),
                    size: 18
                  }, null, 8, ["name"])
                ], 8, ca)
              ], 2)) : h("", !0),
              ce.value ? h("", !0) : (i(), u("button", {
                key: 1,
                class: "lmui-lightbox-actual-button",
                onClick: M(_t, ["stop"]),
                title: a.value.actualSize,
                "aria-label": a.value.actualSize
              }, [...t[14] || (t[14] = [
                v("span", null, "100%", -1)
              ])], 8, va)),
              v("button", {
                class: "lmui-lightbox-toolbar-button",
                onClick: M(ve, ["stop"]),
                title: a.value.resetView,
                "aria-label": a.value.resetView
              }, [
                f(k, {
                  name: g(_l),
                  size: 18
                }, null, 8, ["name"])
              ], 8, da),
              o.showRotate && !ce.value ? (i(), u("button", {
                key: 2,
                class: "lmui-lightbox-toolbar-button",
                onClick: M(pt, ["stop"]),
                title: a.value.rotate,
                "aria-label": a.value.rotate
              }, [
                f(k, {
                  name: g($l),
                  size: 18
                }, null, 8, ["name"])
              ], 8, ma)) : h("", !0)
            ], 64))
          ], 2),
          o.showInfo && !_.value ? (i(), u("div", fa, [
            v("p", ga, [
              Zt(z(s.value + 1) + " / " + z(o.images.length) + " ", 1),
              v("span", ba, z(vt.value) + "%", 1)
            ])
          ])) : h("", !0),
          v("div", {
            class: E(["lmui-lightbox-actions", { "is-mobile": ce.value }])
          }, [
            o.enableDownload && !_.value ? (i(), u("button", {
              key: 0,
              class: E(["lmui-lightbox-action-button", { "is-busy": Y.value, "is-success": he.value }]),
              onClick: M(xt, ["stop"]),
              disabled: Y.value,
              title: a.value.copyImage,
              "aria-label": a.value.copyImage
            }, [
              f(k, {
                name: Y.value ? g(W) : he.value ? g(Ke) : g(kl),
                size: 20,
                class: E({ "animate-spin": Y.value })
              }, null, 8, ["name", "class"])
            ], 10, ya)) : h("", !0),
            o.enableDownload && !_.value ? (i(), u("button", {
              key: 1,
              class: E(["lmui-lightbox-action-button", { "is-busy": q.value, "is-success": fe.value }]),
              onClick: M(kt, ["stop"]),
              disabled: q.value,
              title: a.value.downloadImage,
              "aria-label": a.value.downloadImage
            }, [
              f(k, {
                name: q.value ? g(W) : fe.value ? g(Ke) : g(Ml),
                size: 20,
                class: E({ "animate-spin": q.value })
              }, null, 8, ["name", "class"])
            ], 10, pa)) : h("", !0),
            e.$slots["info-content"] && !_.value ? (i(), u("button", {
              key: 2,
              class: E(["lmui-lightbox-action-button", { "is-active": R.value }]),
              onClick: t[6] || (t[6] = M((n) => R.value = !R.value, ["stop"])),
              title: a.value.imageInfo,
              "aria-label": a.value.imageInfo
            }, [
              f(k, {
                name: g(Ut),
                size: 20
              }, null, 8, ["name"])
            ], 10, wa)) : h("", !0),
            H(e.$slots, "controls-right", Bt(Rt({ currentImage: O.value, currentIndex: s.value, isGalleryMode: _.value })), void 0, !0),
            ce.value ? (i(), u("button", {
              key: 3,
              class: "lmui-lightbox-action-button is-close",
              onClick: M(ft, ["stop"]),
              title: a.value.closeLightbox,
              "aria-label": a.value.closeLightbox
            }, [
              f(k, {
                name: g(Xt),
                size: 24
              }, null, 8, ["name"])
            ], 8, xa)) : h("", !0)
          ], 2),
          o.showSwipeDebug && (C.value !== 0 || P.value) ? (i(), u("div", ka, [
            v("div", Ma, z(Math.round(C.value)) + "px / " + z(pe) + "px threshold ", 1),
            v("div", Ia, [
              t[15] || (t[15] = v("div", { class: "absolute inset-y-0 left-1/2 w-px bg-white/40" }, null, -1)),
              v("div", {
                class: "absolute top-0 bottom-0 bg-blue-400/80 rounded-full transition-none",
                style: A({
                  left: C.value < 0 ? `${50 + Math.max(-50, C.value / pe * 50)}%` : "50%",
                  right: C.value > 0 ? `${50 - Math.min(50, C.value / pe * 50)}%` : "50%",
                  background: Math.abs(C.value) >= pe ? "#4ade80" : "#60a5fa"
                })
              }, null, 4)
            ])
          ])) : h("", !0),
          _.value ? h("", !0) : H(e.$slots, "overlays", { key: 3 }, void 0, !0),
          f(we, { name: "fade" }, {
            default: me(() => [
              R.value && !_.value ? (i(), u("div", {
                key: 0,
                class: "absolute top-20 right-4 z-30 w-72 bg-gray-900/80 backdrop-blur-xl rounded-2xl border border-white/10 shadow-2xl p-5 overflow-hidden",
                onClick: t[8] || (t[8] = M(() => {
                }, ["stop"]))
              }, [
                v("div", _a, [
                  v("div", Ca, [
                    f(k, {
                      name: g(Ut),
                      class: "text-blue-400",
                      size: 18
                    }, null, 8, ["name"]),
                    v("h3", Ta, z(a.value.imageInfo), 1)
                  ]),
                  v("button", {
                    onClick: t[7] || (t[7] = (n) => R.value = !1),
                    class: "text-white/40 hover:text-white transition-colors"
                  }, [
                    f(k, {
                      name: g(Xt),
                      size: 16
                    }, null, 8, ["name"])
                  ])
                ]),
                v("div", $a, [
                  H(e.$slots, "info-content", Bt(Rt({ currentImage: O.value })), void 0, !0)
                ])
              ])) : h("", !0)
            ]),
            _: 3
          }),
          v("div", za, [
            o.showThumbnails && y.value.length > 1 && !_.value ? (i(), u("button", {
              key: 0,
              class: "flex items-center gap-1 px-2 py-0.5 text-white/30 hover:text-white/60 text-[10px] transition-colors",
              onClick: t[9] || (t[9] = M((n) => T.value = !T.value, ["stop"])),
              title: T.value ? a.value.hideThumbnails : a.value.showThumbnails,
              "aria-label": T.value ? a.value.hideThumbnails : a.value.showThumbnails
            }, [
              f(k, {
                name: T.value ? g(pl) : g(xl),
                size: 11
              }, null, 8, ["name"])
            ], 8, Sa)) : h("", !0),
            f(we, {
              "enter-active-class": "transition-all duration-200 ease-out",
              "leave-active-class": "transition-all duration-150 ease-in",
              "enter-from-class": "opacity-0 translate-y-2",
              "leave-to-class": "opacity-0 translate-y-2"
            }, {
              default: me(() => [
                o.showThumbnails && y.value.length > 1 && !_.value && T.value ? (i(), u("div", {
                  key: 0,
                  ref_key: "thumbnailStripRef",
                  ref: ze,
                  class: "lmui-lightbox-thumbnail-strip custom-scrollbar no-scrollbar"
                }, [
                  f(dl, {
                    "enter-active-class": "transition-opacity duration-200 ease-out",
                    "leave-active-class": "transition-opacity duration-150 ease-in",
                    "enter-from-class": "opacity-0",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: me(() => [
                      (i(!0), u(ne, null, Lt(y.value, (n, r) => (i(), u("button", {
                        key: w(n, r),
                        "data-thumb-idx": r,
                        "data-thumb-key": w(n, r),
                        "aria-label": `${a.value.openImage} ${r + 1}`,
                        class: E(["relative shrink-0 w-12 h-12 rounded-lg overflow-hidden border-2 transition-all duration-200", o.gallerySelected?.has(r) ? "border-amber-500 scale-110 shadow-lg shadow-amber-500/20 opacity-100" : s.value === r ? "border-blue-500 scale-110 shadow-lg shadow-blue-500/20" : "border-transparent opacity-50 hover:opacity-100 hover:scale-105"]),
                        onClick: M((c) => o.gallerySelectMode ? I("gallery-item-click", r) : ll(r), ["stop"]),
                        onContextmenu: M((c) => I("thumbnail-contextmenu", { image: n, index: r, x: c.clientX, y: c.clientY }), ["prevent", "stop"]),
                        onTouchstartPassive: (c) => tl(n, r, c),
                        onTouchend: t[10] || (t[10] = (c) => qe()),
                        onTouchmove: t[11] || (t[11] = (c) => qe())
                      }, [
                        n.url ? (i(), xe(Ve, {
                          key: 1,
                          src: n.url,
                          "resolve-src": We,
                          "retry-label": a.value.clickToRetry,
                          compact: ""
                        }, null, 8, ["src", "retry-label"])) : (i(), u("div", Pa, [
                          f(k, {
                            name: g(jt),
                            size: 16,
                            class: "text-white/30"
                          }, null, 8, ["name"])
                        ])),
                        H(e.$slots, "thumbnail-badge", Pt({ ref_for: !0 }, { image: n, index: r }), void 0, !0)
                      ], 42, La))), 128))
                    ]),
                    _: 3
                  }),
                  o.hasMore ? (i(), u("button", {
                    key: 0,
                    type: "button",
                    class: "lmui-lightbox-thumbnail-tail",
                    disabled: o.loadingMore,
                    "aria-label": o.loadingMore ? a.value.loadingMoreImages : a.value.loadMoreImages,
                    onClick: t[12] || (t[12] = M((n) => $(!0), ["stop"]))
                  }, [
                    f(k, {
                      name: o.loadingMore ? g(W) : g(Ot),
                      size: 16,
                      class: E({ "animate-spin": o.loadingMore })
                    }, null, 8, ["name", "class"])
                  ], 8, Ba)) : h("", !0)
                ], 512)) : h("", !0)
              ]),
              _: 3
            })
          ]),
          f(ml, {
            menu: Ee.value,
            onClose: t[13] || (t[13] = (n) => Ee.value = null)
          }, null, 8, ["menu"])
        ], 544)) : h("", !0)
      ]),
      _: 3
    }));
  }
}), qa = /* @__PURE__ */ Je(Da, [["__scopeId", "data-v-5ce415f8"]]), Ea = { class: "lmui-media-viewer-chrome__top" }, Oa = { class: "lmui-media-viewer-chrome__identity" }, ja = { class: "lmui-media-viewer-chrome__title" }, Ua = {
  key: 0,
  class: "lmui-media-viewer-chrome__subtitle"
}, Xa = { class: "lmui-media-viewer-chrome__actions" }, Va = {
  key: 0,
  class: "lmui-media-viewer-chrome__bottom"
}, Za = /* @__PURE__ */ Ze({
  __name: "BaseMediaViewerChrome",
  props: {
    title: {},
    subtitle: { default: "" },
    hidden: { type: Boolean, default: !1 },
    showBottomControls: { type: Boolean, default: !0 }
  },
  setup(o) {
    return (d, b) => (i(), u("div", {
      class: E(["lmui-media-viewer-chrome", { "lmui-media-viewer-chrome--hidden": o.hidden }])
    }, [
      v("div", Ea, [
        v("div", Oa, [
          H(d.$slots, "identity", {}, () => [
            v("p", ja, z(o.title), 1),
            o.subtitle ? (i(), u("p", Ua, z(o.subtitle), 1)) : h("", !0)
          ], !0)
        ]),
        v("div", Xa, [
          H(d.$slots, "top-actions", {}, void 0, !0)
        ])
      ]),
      o.showBottomControls && d.$slots["bottom-controls"] ? (i(), u("div", Va, [
        H(d.$slots, "bottom-controls", {}, void 0, !0)
      ])) : h("", !0)
    ], 2));
  }
}), Wa = /* @__PURE__ */ Je(Za, [["__scopeId", "data-v-e73801dd"]]), Na = { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-9 h-9 bg-white rounded-full shadow-xl flex items-center justify-center" }, Fa = { class: "absolute top-4 left-4 z-20 px-2.5 py-1 bg-black/50 backdrop-blur-sm rounded-full text-white/70 text-[10px] font-medium border border-white/10 pointer-events-none" }, Ha = /* @__PURE__ */ Ze({
  __name: "ImageCompareOverlay",
  props: {
    visible: { type: Boolean, default: !1 },
    images: {},
    resolveImageUrl: {},
    labels: {}
  },
  emits: ["close"],
  setup(o, { emit: d }) {
    const b = o, l = d, I = p(() => ({
      close: "Close compare",
      left: "A",
      right: "B",
      ...b.labels
    })), a = m(50), s = m(null);
    let R = !1;
    j(() => b.visible, (w) => {
      w && (a.value = 50);
    });
    function T(w) {
      return b.resolveImageUrl ? b.resolveImageUrl(w) : Promise.resolve(w);
    }
    function y(w) {
      R = !0, w.currentTarget.setPointerCapture(w.pointerId);
    }
    function O(w) {
      if (!R) return;
      const U = s.value?.getBoundingClientRect();
      U && (a.value = Math.max(3, Math.min(97, (w.clientX - U.left) / U.width * 100)));
    }
    function X() {
      R = !1;
    }
    return (w, U) => (i(), xe(we, {
      "enter-active-class": "transition-opacity duration-300",
      "leave-active-class": "transition-opacity duration-200",
      "enter-from-class": "opacity-0",
      "leave-to-class": "opacity-0"
    }, {
      default: me(() => [
        o.visible && o.images ? (i(), u("div", {
          key: 0,
          ref_key: "containerRef",
          ref: s,
          class: "absolute inset-0 z-40 bg-black overflow-hidden select-none touch-none"
        }, [
          v("div", {
            class: "absolute inset-0 overflow-hidden",
            style: A({ clipPath: `inset(0 ${100 - a.value}% 0 0)` })
          }, [
            f(Ve, {
              src: o.images[0].url,
              "resolve-src": T,
              "object-fit": "contain"
            }, null, 8, ["src"])
          ], 4),
          v("div", {
            class: "absolute inset-0 overflow-hidden",
            style: A({ clipPath: `inset(0 0 0 ${a.value}%)` })
          }, [
            f(Ve, {
              src: o.images[1].url,
              "resolve-src": T,
              "object-fit": "contain"
            }, null, 8, ["src"])
          ], 4),
          v("div", {
            class: "absolute top-0 bottom-0 w-1 -translate-x-1/2 bg-white/70 shadow-lg cursor-ew-resize z-10",
            style: A({ left: `${a.value}%` }),
            onPointerdown: M(y, ["prevent"]),
            onPointermove: O,
            onPointerup: X,
            onPointercancel: X
          }, [
            v("div", Na, [
              f(k, {
                name: "ChevronsLeftRight",
                size: 16,
                class: "text-gray-600"
              })
            ])
          ], 36),
          v("button", {
            class: "absolute top-4 right-4 z-20 flex items-center gap-1.5 px-3 py-1.5 bg-black/50 hover:bg-black/70 backdrop-blur-sm text-white rounded-full text-xs font-medium border border-white/10 transition-colors",
            onClick: U[0] || (U[0] = (ke) => l("close"))
          }, [
            f(k, {
              name: "X",
              size: 13
            }),
            Zt(" " + z(I.value.close), 1)
          ]),
          v("div", Fa, z(I.value.left), 1),
          v("div", {
            class: "absolute top-4 z-20 px-2.5 py-1 bg-black/50 backdrop-blur-sm rounded-full text-white/70 text-[10px] font-medium border border-white/10 pointer-events-none",
            style: A({ left: `calc(${a.value}% + 1rem)` })
          }, z(I.value.right), 5)
        ], 512)) : h("", !0)
      ]),
      _: 1
    }));
  }
});
export {
  qa as BaseImageLightbox,
  Ve as BaseImageLoader,
  Wa as BaseMediaViewerChrome,
  Ha as ImageCompareOverlay
};
